export default __webpack_public_path__ + "static/media/wallet_icon_white.414e4e8e.svg";